import axios from './axios'
import { ElLoading } from 'element-plus'


export function getOrderList (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.get(`/order_oper/search?offset=${param.offset}&limit=${param.limit}&keywords=${param.keywords}`,{
    baseURL:"/shop"
  }).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}
/**
 * 修改消费单 关联单号
 * @param {} param
 * @param {*} callbackFun
 */
export function finishOrder (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/order_oper/finish', param,{
    baseURL:"/shop"
  }).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}